/** ISO or parseable run timestamp for snapshot slide header (matches run-history table formatting). */
export function formatRunSnapshotHeaderDate(raw: string | undefined | null): string | null {
  const s = String(raw ?? '').trim();
  if (!s) return null;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** One-line header: analysis name · formatted run date · run by. */
export function buildRunSnapshotMetaOneLine(
  analysisName: string,
  runDateRaw: string | undefined | null,
  runBy: string | undefined | null
): string {
  const dateFmt = formatRunSnapshotHeaderDate(runDateRaw);
  const parts = [String(analysisName ?? '').trim() || null, dateFmt, String(runBy ?? '').trim() || null].filter(
    Boolean
  );
  return parts.join(' · ');
}
